'use strict';

const _throwOnMissingKey = require('../_throwOnMissingKey');
const _throwOnUpdateScalar = require('../_throwOnUpdateScalar');
const getCheckerAt = require('../../rlink-shapes/getCheckerAt');
const operations = require('../operations');

module.exports = function makeShapeTemplate (shape) {
  let collections = this;
  let templatedMethods = {
    getAt (obj, path = [], coveredPath = [], onMissingKey = _throwOnMissingKey) {
      return collections.getAt(obj, path, coveredPath,
        //onMissingKey
        (incompleteObj, pathToIncompleteObj, missingKey, remainingPath) => {
          // this can be called for two reasons:
          // 1) there is still path left but the current object is not
          // a collection
          if (!collections.isCollection(incompleteObj)) {
            let checker = getCheckerAt(shape, pathToIncompleteObj);
            if (checker && typeof checker.makeNew === 'function') {
              return templatedMethods.getAt(checker.makeNew(),
                [missingKey].concat(remainingPath), pathToIncompleteObj, onMissingKey);
            } else {
              return onMissingKey(incompleteObj, pathToIncompleteObj, missingKey, remainingPath);
            }
          // 2) OR, the current object is a collection, but simply
          // doesn't have the next key
          } else {
            let pathToMissingKey = pathToIncompleteObj.concat(missingKey);
            let checker = getCheckerAt(shape, pathToMissingKey);
            if (checker && typeof checker.makeNew === 'function') {
              return templatedMethods.getAt(checker.makeNew(),
                remainingPath, pathToMissingKey, onMissingKey);
            } else {
              return onMissingKey(incompleteObj, pathToIncompleteObj, missingKey, remainingPath);
            }
          }
        }
      );
    },
    setAt (obj, path, value) {
      return templatedMethods.updateAt(obj, [[path, operations.set, value]]);
    },
    updateAt (initialObj, initialOps, coveredPath = [], onUpdateScalar = _throwOnUpdateScalar) {
      return collections.updateAt(initialObj, initialOps, coveredPath,
        // onUpdateScalar
        (scalarObj, operations, pathToScalarObject) => {
          let checker = getCheckerAt(shape, pathToScalarObject);
          if (checker && typeof checker.makeNew === 'function') {
            let newObj = checker.makeNew();
            if (collections.isIterable(newObj)) {
              // try again with non-scalar value from shape:
              return templatedMethods.updateAt(checker.makeNew(),
                operations, pathToScalarObject);
            }
          }
          return onUpdateScalar(scalarObj, operations, pathToScalarObject);

        }
      );
    },
  };
  return templatedMethods;
};



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/makeShapeTemplate.js